export default {
  validate(value, args) {
    return true;
  },
};
